import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pub-menu',
  templateUrl: './pub-menu.component.html',
  styleUrls: ['./pub-menu.component.css']
})
export class PubMenuComponent implements OnInit {

  /**
   *
   * @type {EventEmitter<any>}
   */
  @Output() onHomeEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  /**
   * Metodo invocado al seleccionar la opcion Inicio
   */
  onHomeClicked() {
    this.onHomeEvent.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/app-public/pub-menu/pub-menu.component.ts